<div class="request-type-sidebar">
  <section>
    <p>Tipo de pedido</p>
    <h2>
      {{ title }} - <span>{{ subTitle }}</span>
    </h2>
  </section>
</div>
